/*
 * SCR-011 "Inspírate con la comunidad" below the upload flow (Figma 15:693 "Community catalog", tablet 17:34821, mobile
 * 17:34587). Phase A1. Reads and writes only through NcApp.gateway() (the mock in A1): getCommunity (the looks), getAsset
 * (photos), setLookLike, setLookSaved and getLook (its garments, for "Probar"). No network, no persistence of its own.
 * Sorts: 0 "Para ti" keeps the gateway order, 1 "Más recientes" by createdAt, 2 "Más populares" by likes. "Cargar más looks"
 * shows the next page of `pageSize` cards; it is hidden when everything is shown. "Probar" puts the look's garments into the
 * current look (window.NcFittingRoom.addMany, as in the community feed); the title fires `nc-upload-community:open`
 * {kind: 'look', id}, which assets/nc-nav.js turns into the look detail (R-8). Copy comes from data-texts ('|' list, see the
 * section schema). Pure helpers are exported for node:test.
 */
(function () {
  // "{n} look/{n} looks" with n: the first form for exactly 1
  function countText(pattern, n) {
    var parts = String(pattern || '').split('/');
    var form = parts.length > 1 && n !== 1 ? parts[1] : parts[0];
    return form.replace('{n}', String(n));
  }

  function sortLooks(looks, mode) {
    var list = looks.slice();
    if (mode === 1) list.sort(function (a, b) { return String(b.createdAt || '').localeCompare(String(a.createdAt || '')); });
    if (mode === 2) list.sort(function (a, b) { return (b.likes || 0) - (a.likes || 0); });
    return list;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { countText: countText, sortLooks: sortLooks };
  }
  if (typeof customElements === 'undefined' || customElements.get('nc-upload-community')) return;

  function noop() {}

  class NcUploadCommunity extends HTMLElement {
    connectedCallback() {
      if (!window.NcApp) return;
      this.gw = window.NcApp.gateway();
      this.t = String(this.getAttribute('data-texts') || '').split('|').map(function (x) { return x.trim(); });
      this.pageSize = 12;
      this.shown = this.pageSize;
      this.mode = 0;
      this.items = [];
      this.grid = this.querySelector('[data-uc-grid]');
      this.count = this.querySelector('[data-uc-count]');
      this.more = this.querySelector('[data-uc-more]');
      this.state = this.querySelector('[data-uc-state]');
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('nc-chip:toggle', this.onSort.bind(this));
      this.addEventListener('nc-card:toggle', this.onToggle.bind(this));
      this.load();
    }

    load() {
      var self = this;
      this.state.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.gw.getCommunity({}).then(function (res) {
        self.items = (res && res.items) || [];
        self.grid.setAttribute('aria-busy', 'false');
        if (!self.items.length) { self.showState(8, 9, false); return; }
        self.render();
      }, function () {
        self.grid.setAttribute('aria-busy', 'false');
        self.showState(10, 11, true);
      });
    }

    showState(title, body, retry) {
      this.grid.textContent = '';
      this.count.textContent = '';
      this.more.hidden = true;
      this.state.querySelector('[data-uc-state-title]').textContent = this.t[title] || '';
      this.state.querySelector('[data-uc-state-body]').textContent = this.t[body] || '';
      this.state.querySelector('[data-uc-retry]').hidden = !retry;
      this.state.hidden = false;
    }

    fill(pattern, title) { return String(pattern || '').replace('{title}', title || ''); }

    render() {
      var self = this;
      var tpl = this.querySelector('template[data-uc-tpl="look"]');
      var list = sortLooks(this.items, this.mode).slice(0, this.shown);
      this.grid.textContent = '';
      list.forEach(function (l, i) {
        var li = tpl.content.querySelector('li').cloneNode(true);
        li.setAttribute('data-id', l.id);
        var link = li.querySelector('[data-uc-open]');
        link.textContent = l.title || '';
        link.setAttribute('data-id', l.id);
        li.querySelector('[data-uc-garments]').textContent = countText(self.t[15], l.garmentCount || 0);
        var like = li.querySelector('.nc-toggle--like');
        like.setAttribute('data-id', l.id);
        like.setAttribute('data-count', String(l.likes || 0));
        like.setAttribute('data-initial-pressed', l.liked ? 'true' : 'false');
        like.setAttribute('aria-pressed', l.liked ? 'true' : 'false');
        like.setAttribute('aria-label', self.fill(self.t[18], l.title));
        var save = li.querySelector('.nc-toggle--save');
        save.setAttribute('data-id', l.id);
        save.setAttribute('aria-pressed', l.saved ? 'true' : 'false');
        save.setAttribute('aria-label', self.fill(self.t[19], l.title));
        var tryBtn = li.querySelector('.nc-upload-look__look-actions .nc-button');
        tryBtn.setAttribute('data-uc-try', l.id);
        tryBtn.setAttribute('aria-label', self.fill(self.t[20], l.title));
        self.grid.appendChild(li);
        self.applyAsset(li.querySelector('.nc-card__media'), l.assetId, l.title, false);
      });
      this.count.textContent = countText(this.t[7], this.items.length);
      this.more.hidden = this.items.length <= this.shown;
    }

    // images enter only through the gateway's asset records; no src leaves the neutral slot
    applyAsset(slot, assetId, alt) {
      if (!slot || !assetId || !this.gw.getAsset) return;
      this.gw.getAsset(assetId).then(function (a) {
        if (!a || !a.src || !slot.isConnected) return;
        var img = document.createElement('img');
        img.src = a.src;
        if (a.width) img.width = a.width;
        if (a.height) img.height = a.height;
        img.alt = a.alt || alt || '';
        img.loading = 'lazy';
        slot.insertBefore(img, slot.firstChild);
      }, noop);
    }

    onSort(event) {
      var chip = event.target.closest('nc-chip');
      var group = chip && chip.closest('[data-uc-sorts]');
      if (!group) return;
      var chips = Array.prototype.slice.call(group.querySelectorAll('nc-chip'));
      chips.forEach(function (c) { var m = c.querySelector('.nc-chip__main'); if (m) m.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      this.mode = chips.indexOf(chip);
      this.shown = this.pageSize;
      this.render();
    }

    onClick(event) {
      var t = event.target;
      if (t.closest('[data-uc-retry]')) { this.load(); return; }
      if (t.closest('[data-uc-more] .nc-button')) { this.shown += this.pageSize; this.render(); return; }
      var tryBtn = t.closest('[data-uc-try]');
      if (tryBtn) { this.tryLook(tryBtn.getAttribute('data-uc-try')); return; }
      var open = t.closest('[data-uc-open]');
      if (open) {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('nc-upload-community:open', { bubbles: true, detail: { kind: 'look', id: open.getAttribute('data-id') } }));
      }
    }

    tryLook(lookId) {
      var fitting = window.NcFittingRoom;
      if (!fitting || !fitting.addMany) return Promise.resolve(null);
      var copy = { added: this.t[21], error: this.t[22] };
      return this.gw.getLook(lookId).then(function (look) {
        return fitting.addMany((look.products || []).map(function (p) { return p.id; }));
      }).then(function (r) { fitting.notify(r, copy); return r; }, function () { fitting.notify({ status: 'error' }, copy); return null; });
    }

    // like / save: optimistic in nc-card.js, then the gateway write; a failure rolls the control back
    onToggle(event) {
      var d = event.detail;
      var button = event.target.closest('.nc-toggle');
      if (!button || !window.NcCard) return;
      var isLike = d.kind === 'like';
      var self = this;
      window.NcCard.setState(button, 'loading');
      var write = isLike ? this.gw.setLookLike({ lookId: d.id, value: d.pressed }) : this.gw.setLookSaved({ lookId: d.id, value: d.pressed });
      write.then(function () {
        window.NcCard.setState(button, 'default');
        var it = self.items.filter(function (x) { return x.id === d.id; })[0];
        if (it && isLike && it.liked !== d.pressed) { it.likes = (it.likes || 0) + (d.pressed ? 1 : -1); it.liked = d.pressed; }
        if (it && !isLike) it.saved = d.pressed;
      }, function () {
        window.NcCard.setState(button, 'error', button.getAttribute('data-error-label') || '');
      });
    }
  }

  customElements.define('nc-upload-community', NcUploadCommunity);
})();
